import { config } from "../env";
import {
  Delete,
  DeleteWithPayload,
  get,
  patch,
  post,
} from "./helpers/http-handler";

export const getComplianceReports = (queryRequest: string) =>
  get(
    `${
      config.API_URL
    }/reports?${queryRequest}`
  );

export const getSpecificComplianceReports = (id: string) =>
  get(
    `${
      config.API_URL
    }/reports/${id}`
  );

export const deleteComplianceReports = (payload: object) =>
  DeleteWithPayload(
    `${
      config.API_URL
    }/reports`,
    payload
  );

export const runReport = (payload: object) =>
  post(
    `${
      config.API_URL
    }/reports`,
    payload
  );

export const updateReport = (id: string, payload: object) =>
  patch(
    `${
      config.API_URL
    }/reports/${id}`,
    payload
  );

export const adminReportsShowHideColumns = () =>
  get(
    `${
      config.API_URL
    }/reports/show-hide-column`
  );

export const createUploadReport = (payload: object) =>
  post(
    `${
      config.API_URL
    }/reports/uploads`,
    payload
  );

export const createHeadcountReport = (payload: object) =>
  post(
    `${
      config.API_URL
    }/reports/headcount`,
    payload
  );

export const createDailyUpload = (payload: object) =>
  post(
    `${
      config.API_URL
    }/reports/daily-upload`,
    payload
  );

export const createDailyAudit = (payload: object) =>
  post(
    `${
      config.API_URL
    }/reports/daily-audit`,
    payload
  );

export const createConsolidateReport = (payload: object) =>
  post(
    `${
      config.API_URL
    }/reports/consolidate`,
    payload
  );

export const createComplianceTaskReport = (payload: object) =>
  post(
    `${
      config.API_URL
    }/reports/compliance/task`,
    payload
  );

export const legalUpdate = (payload: object) =>
  post(
    `${
      config.API_URL
    }/legal-update/getblogs`,
    payload
  );

export const documentLibrary = (payload: object) =>
  post(
    `${
      config.API_URL
    }/document-library/get-documents`,
    payload
  );

export const createVendoAuditReport = (payload: object) =>
  post(
    `${
      config.API_URL
    }/reports/vendor-audit-report`,
    payload
  );

export const createLicenseCertificateReport = (payload: object) =>
  post(
    `${
      config.API_URL
    }/reports/license-consolidate`,
    payload
  );
